import { render, staticRenderFns } from "./CreateNoiseBlock.vue?vue&type=template&id=fe8e10bc&scoped=true"
import script from "./CreateNoiseBlock.vue?vue&type=script&lang=js"
export * from "./CreateNoiseBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8e10bc",
  null
  
)

export default component.exports